import { gql, useQuery } from '@apollo/client'

import type { OverrideIncomeRequest } from '@/components/EntityPanels/VerifyIncome/types'
import agentClient from '@/lib/apollo/client/agent'
import type { OutcomeStatus } from '@/lib/apollo/model/outcome'
import type { WrappedUseQuery } from '@/lib/apollo/types'

const getOverrideIncomeResultQuery = gql`
  query ($overrideIncomeRequest: OverrideIncomeRequest!) {
    getOverrideIncomeResult(overrideIncomeRequest: $overrideIncomeRequest) {
      totalAmountVerified
      outcomeStatus
      decisionComments
    }
  }
`

type OverrideIncomeResult = {
  outcomeStatus: OutcomeStatus
  totalAmountVerified: number
  decisionComments: string[]
}

export type GetIncomeResultData = {
  getOverrideIncomeResult: OverrideIncomeResult | null
}

export type QueryVars = {
  overrideIncomeRequest: OverrideIncomeRequest
}

export const useGetOverrideIncomeResultQuery: WrappedUseQuery<
  GetIncomeResultData,
  QueryVars
> = options =>
  useQuery<GetIncomeResultData, QueryVars>(getOverrideIncomeResultQuery, {
    ...options,
    client: agentClient,
  })
